export enum ImpDataType {
  RAW = 'RAW_SKU',
  RAW_FIX = 'RAW_SKU_FIX',
  KOL = 'KOL',
  EC_CATE = 'EC_CATEGORY',
  CUST_CATE = 'CUSTOM_CATEGORY',
  SUPER_CATE = 'SUPER_CATEGORY',
  GPY_SEED = 'GPY_SEED',
  GPY_RAW = 'GPY_RAW',
}
